import { Input as InputANTD, InputProps } from 'antd';
import { useField } from 'formik';

import { getTrimmedValue } from 'src/utils';

interface IProps extends InputProps {
  name?: string;
  handleChange?: (value: string) => void;
  handleBlur?: (value: string) => void;
  handleFocus?: (value: string) => void;
  trimOnBlur?: 'start' | 'end' | 'all';
}

export const Input = ({ name = '', handleChange, handleBlur, handleFocus, onBlur, onFocus, trimOnBlur, ...restProps }: IProps) => {
  const [field, _meta, helpers] = useField(name);

  return (
    <InputANTD
      value={field.value}
      onChange={async (e) => {
        await helpers.setValue(e.target.value);

        if (typeof handleChange === 'function') {
          handleChange(e.target.value);
        }
      }}
      onBlur={async (e) => {
        if (typeof onBlur === 'function') {
          onBlur(e);
        }

        const trimmedValue = trimOnBlur ? getTrimmedValue(e.target.value, trimOnBlur) : e.target.value;

        if (trimOnBlur) {
          await helpers.setValue(trimmedValue);
        }

        if (typeof handleBlur === 'function') {
          handleBlur(trimmedValue);
        }
      }}
      onFocus={(e) => {
        if (typeof onFocus === 'function') {
          onFocus(e);
        }

        if (typeof handleFocus === 'function') {
          handleFocus(e.target.value);
        }
      }}
      {...restProps}
    />
  );
};
